import {EventBus} from "../../events";

const state = {
    filter: null,
};
const actions = {
    updated() {
        EventBus.$emit('filter_updated');
    }
};
const mutations = {
    set(state, filter) {
        state.filter = filter;
    },
};
const getters = {
    get(state) {
        return state.filter;
    }
};

export const filter = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
